import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { formatMessage } from 'translate';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { SubmissionError } from 'redux-form';
import TwoKeyStorage from '../../../_core/2KeyStorage';
import { loadHistory } from '../../../_core/utils';
import { BusinessActions, UserActions } from '../../../_redux';
import AppContext from '../../../context';
import { getSearchParams } from '../../../_core/queryparams';

// const resolveCaptcha = async hCaptcha => {
//   try {
//     const body = {};
//     const cookieKey = hCaptcha ? 'hCaptcha' : 'reCaptcha';
//     if (Cookies.get(cookieKey)) {
//       return;
//     }
//     if (hCaptcha) {
//       body['h-captcha-response'] = hCaptcha;
//       body.captcha_type = 'hcaptcha';
//     } else {
//       body.recaptcha = await executeRecaptcha('auth');
//       body.captcha_type = 'recaptcha';
//     }
//     const captchaJwt = await fetchAPI('captcha', {
//       method: 'POST',
//       body: JSON.stringify(body),
//     });
//     Cookies.set(cookieKey, captchaJwt, { expires: new Date(Date.now() + (15 * 60000)) });
//   } catch (error) {
//     throw new Error('Invalid reCaptcha');
//   }
// };

const initialState = {
  loggingThroughCredentials: false,
  loadingSignup: false,
  resettingPassword: false,

  resetResult: '',
  errorMessage: '',
  globalLoading: false,
};


class AuthContainerComponent extends PureComponent {
  static contextType = AppContext;

  constructor(props) {
    super(props);

    const { uuid } = getSearchParams(window.location.search);
    // const showHCaptcha = TwoKeyStorage.getItem('showHCaptcha');

    this.state = {
      ...initialState,
      globalLoading: Boolean(uuid),
      // showHCaptcha,
    };
  }

  componentDidMount() {
    const { uuid } = getSearchParams(window.location.search);
    if (uuid) {
      // TODO: add loader for this case
      this.handleCivicByUrl();
    }
  }

  onHCaptchaVerify = hCaptcha => {
    this.setState({ hCaptcha });
    TwoKeyStorage.setItem('hCaptcha', hCaptcha, 15 * 60 * 1000);
    // try {
    //   const captchaJwt = await fetchAPI('captcha', {
    //     method: 'POST',
    //     body: JSON.stringify({
    //       'h-captcha-response': hCaptcha,
    //       captcha_type: 'hcaptcha',
    //     }),
    //   });
    //   Cookies.set('hCaptcha', captchaJwt, { expires: new Date(Date.now() + (15 * 60000)) });
    // } catch (error) {
    //   throw new Error('Invalid reCaptcha');
    // }
  }

  onHCaptchaExpire = () => {
    this.setState({ hCaptcha: null });
  }

  loginWithFaceBook = () => {
    this.context.auth.auth0.authorize({
      connection: 'facebook',
      scope: 'openid profile email read:users read:user_idp_tokens',
    }, (err, res) => {
      if (err) {
        const errorMessage = document.getElementById('error-message');
        errorMessage.innerHTML = err.description;
        errorMessage.style.display = 'block';
      } else {
        console.log('=======FACEBOOKLOGINRESULT', res);
      }
    });
  }

  loginWithGoogle = () => {
    this.context.auth.auth0.authorize({
      connection: 'google-oauth2',
    }, err => {
      if (err) {
        const errorMessage = document.getElementById('error-message');
        errorMessage.innerHTML = err.description;
        errorMessage.style.display = 'block';
      }
    });
  }

  loginWithTwitter = () => {
    this.context.auth.auth0.authorize({
      connection: 'twitter',
    }, err => {
      if (err) {
        const errorMessage = document.getElementById('error-message');
        errorMessage.innerHTML = err.description;
        errorMessage.style.display = 'block';
      }
    });
  }

  loginWithCivic = () => {
    this.setState({ globalLoading: true });

    return this.context.auth.loginWithCivic()
      .then(res => {
        const { isUserNew } = res;
        // this.props.PATCH_USER_METADATA(user);
        if (!isUserNew) {
          const { FETCH_BUSINESS_LIST, FETCH_USER_METADATA } = this.props;

          Promise.all(FETCH_BUSINESS_LIST(), FETCH_USER_METADATA())
            .catch(console.warn)
            .finally(() => {
              const route = TwoKeyStorage.getItem('route') || '/i/home';
              if (TwoKeyStorage.getItem('route')) {
                TwoKeyStorage.removeItem('route');
              }
              window.location.replace(route);
              this.setState({ globalLoading: false });
            });
        } else {
          this.setState({ globalLoading: false });
        }

        return isUserNew;
      }).catch(() => this.setState({ globalLoading: false }));
    // .finally(() => {
    //   this.setState({ globalLoading: false });
    // });
  }

  signupWithCivic = ({ firstName = '', lastName = '' }) => {
    const { UPDATE_USER_PROFILE } = this.props;
    this.setState({ loadingSignup: true });
    Promise.resolve(UPDATE_USER_PROFILE({ first_name: firstName, last_name: lastName }))
      .then(() => {
        this.setState({ loadingSignup: false });
      })
      .catch(err => {
        this.setState({ loadingSignup: false, errorMessage: err.message });
      });
  }
  /**
   * only for global auth modal component
   */
  handleCivicByUrl = () => {
    const { PATCH_USER_METADATA, history } = this.props;
    this.setState({ globalLoading: true });

    this.context.auth.handleCivicCallback()
      .then(res => {
        const { user, isUserNew } = res;
        PATCH_USER_METADATA(user);
        if (isUserNew) {
          history.push('/signup/civic');
        } else {
          const route = TwoKeyStorage.getItem('route') || loadHistory(user);
          TwoKeyStorage.removeItem('route');
          history.push(route);
        }
      })
      .catch(err => {
        console.error(err);
      })
      .finally(() => {
        this.setState({ globalLoading: false });
      });
  }

  handleLoginWithMail = async({ email, password }) => {
    this.setState({
      loggingThroughCredentials: true,
      errorMessage: initialState.errorMessage,
    });

    try {
      if (!email || email.trim() === '' || !password || password.trim() === '') {
        throw new Error('Both Username and Password are required');
      }

      // await resolveCaptcha(this.state.hCaptcha);

      await this.context.auth.loginWithCredentials(email, password);

      this.setState({
        loggingThroughCredentials: false,
      });
    } catch (error) {
      this.setState({
        loggingThroughCredentials: false,
        errorMessage: error.description || error.message,
      });
      throw new SubmissionError({
        password: error.description || error.message,
        // email: ' ',
      });
    }
  }

  handleLoginPasswordLess = async({ emailPasswordLess, phoneNumber }) => {
    this.setState({
      loggingThroughCredentials: true,
      errorMessage: initialState.errorMessage,
    });

    try {
      if ((!emailPasswordLess || emailPasswordLess.trim() === '') && (!phoneNumber || phoneNumber.trim() === '')) {
        throw new Error('Email or PhoneNumber is required');
      }

      // await resolveCaptcha(this.state.hCaptcha);

      await this.context.auth.loginWithPasswordLess(emailPasswordLess, phoneNumber);

      this.setState({
        loggingThroughCredentials: false,
        passwordLess: emailPasswordLess || phoneNumber,
      });
      return emailPasswordLess || phoneNumber;
    } catch (error) {
      console.warn(error);
      this.setState({
        loggingThroughCredentials: false,
        errorMessage: error.description || error.message,
      });
      throw new SubmissionError({
        password: error.description || error.message,
        email: ' ',
      });
    }
  }

  handleSignupWithMail = ({
    email, password, firstName = '', lastName = '', handle = '', subscribe = false,
  }) => new Promise(async(resolve, reject) => {
    if ([email, password, firstName, lastName, handle].some(value => !value)) {
      return;
    }
    this.setState({
      loadingSignup: true,
      errorMessage: initialState.errorMessage,
    });

    try {
      // await resolveCaptcha(this.state.hCaptcha);

      const { CONFIG: { environment } } = window;
      const user_metadata = environment === 'production'
        ? {
          firstName, lastName, handle, subscribe: subscribe.toString(),
        }
        : {
          test_firstName: firstName,
          test_lastName: lastName,
          test_handle: handle,
          test_subscribe: subscribe.toString(),
        };
      const connection = 'Username-Password-Authentication';
      await (new Promise((auth0Resolve, auth0Reject) => {
        this.context.auth.auth0.signup({
          username: handle,
          connection,
          email,
          password,
          user_metadata,
        }, err => {
          if (err) {
            let msg = '';
            if (!!err.name && err.name === 'PasswordStrengthError') {
              const translateMsg = formatMessage({ id: 'auth.strong_password' });
              msg = `${translateMsg} <br />${err.policy.replace(/\n/g, '<br />')}`;
            } else if (err.message && err.message !== '') {
              msg = err.message;
            } else {
              msg = err.description;
              console.log(err);
            }
            this.setState({ loadingSignup: false, errorMessage: msg });
            auth0Reject(err);
            return;
          }
          this.setState({ loadingSignup: false });
          auth0Resolve();
        });
      }));
      resolve();
    } catch (error) {
      this.setState({
        loadingSignup: false,
        errorMessage: error.description || error.message,
      });
      reject(error);
    }
  })

  loginAfterSignup = ({ email, password }) => {
    this.setState({ loggingThroughCredentials: true });
    return this.context.auth.loginWithCredentials(email, password)
      .then(() => {
        this.setState({ errorMessage: '' });
      })
      .catch(error => {
        this.setState({ errorMessage: error });
      }).finally(() => {
        this.setState({ loggingThroughCredentials: false });
      });
  }

  resetPassword = ({ email }) => {
    this.setState({ resettingPassword: true });
    const connection = 'Username-Password-Authentication';
    return new Promise((resolve, reject) => {
      this.context.auth.auth0.changePassword({
        connection,
        email,
      }, (err, resetResult) => {
        let errorMessage = '';

        if (err) {
          const { name, message, description } = err || {};
          errorMessage = message || name || description;
        }

        this.setState({
          errorMessage,
          resettingPassword: false,
          resetEmail: email,
          resetResult,
        });

        if (errorMessage) {
          reject(new SubmissionError({
            password: errorMessage,
            email: ' ',
          }));
        } else {
          resolve();
        }
      });
    });
  };

  resetSecondaryData = () => {
    this.setState({
      errorMessage: initialState.errorMessage,
      resetResult: initialState.resetResult,
    });
  }

  render() {
    const { component: Component } = this.props;
    const {
      loggingThroughCredentials, errorMessage,
      loadingSignup, resettingPassword, resetResult, globalLoading,
      passwordLess, resetEmail, hCaptcha,
    } = this.state;

    const props = {
      loggingThroughCredentials,
      errorMessage,
      loadingSignup,
      resettingPassword,
      resetResult,
      resetEmail,
      globalLoading,
      passwordLess,
      hCaptcha,

      handleMailLogin: this.handleLoginWithMail,
      handleLoginPasswordLess: this.handleLoginPasswordLess,
      handleMailSignUp: this.handleSignupWithMail,
      handleCivicSignUp: this.signupWithCivic,
      resetPassword: this.resetPassword,

      handleGoogleLogin: this.loginWithGoogle,
      handleTwitterLogin: this.loginWithTwitter,
      handleFacebookLogin: this.loginWithFaceBook,
      handleCivicLogin: this.loginWithCivic,
      handleCivicByUrl: this.handleCivicByUrl,
      loginAfterSignup: this.loginAfterSignup,
      resetSecondaryData: this.resetSecondaryData,
      onHCaptchaVerify: this.onHCaptchaVerify,
      onHCaptchaExpire: this.onHCaptchaExpire,
      ...this.props,
    };

    return (
      <Component {...props} />
    );
  }
}

AuthContainerComponent.propTypes = {
  component: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired,
  FETCH_BUSINESS_LIST: PropTypes.func.isRequired,
  FETCH_USER_METADATA: PropTypes.func.isRequired,
  UPDATE_USER_PROFILE: PropTypes.func.isRequired,
  PATCH_USER_METADATA: PropTypes.func.isRequired,
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};

AuthContainerComponent.defaultProps = {};

const mapStateToProps = undefined;
const mapDispatchToProps = {
  FETCH_BUSINESS_LIST: BusinessActions.FETCH_BUSINESS_LIST,
  FETCH_USER_METADATA: UserActions.FETCH_USER_METADATA,
  UPDATE_USER_PROFILE: UserActions.UPDATE_USER_PROFILE,
  PATCH_USER_METADATA: UserActions.PATCH_USER_METADATA,
};


const AuthContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(AuthContainerComponent));

export default AuthContainer;
